<script setup lang="ts">
import { onMounted, ref } from 'vue';

defineEmits(['click']);

const props = defineProps<{
	url?: string;
	isDownload: boolean;
	iconName?: string;
	ariaLabel: string;
	disabled: boolean;
}>();

const link = ref();

onMounted(() => {
	if (props.isDownload) link.value.setAttribute('download', '');
});
</script>
<template>
	<a
		ref="link"
		:href="url || undefined"
		:class="['icon-button link', { 'link--disabled': !url || url === 'null' || disabled }]"
		rel="noopener noreferrer"
		:aria-label="ariaLabel"
		data-ts="btn-link"
	>
		<span
			data-ts="icon"
			:class="`icon-button__icon bx ${isDownload ? 'bx-download' : iconName}`"
		/>
	</a>
</template>
<style lang="scss" scoped>
.link {
	border-radius: 0;
	box-shadow: 0 2px 0 black;

	@media (hover: hover) {
		&:hover {
			border-radius: $border-radius-2;
			box-shadow: none;
		}
	}

	&:not([href]),
	&--disabled {
		pointer-events: none;
		cursor: not-allowed;
		color: $color-gray-500;
		box-shadow: 0 2px 0 $color-gray-400;
	}
}
</style>
